export default __webpack_public_path__ + "static/media/Flames.d8fa53a3.png";